import { useLocalStorage } from "@rehooks/local-storage";
import { useEffect } from "react";

import { syncColumnsOrder } from "ds/components/Table/store/useTableStore/syncColumnsOrder";

import { CustomizeViewConfig } from "./types";

export const useSyncColumnsConfig = <T extends string>({
  storageKey,
  defaultConfig,
}: {
  storageKey: string;
  defaultConfig: CustomizeViewConfig<T>;
}) => {
  const [storageConfig, setStorageConfig] = useLocalStorage<CustomizeViewConfig<T>>(
    storageKey,
    defaultConfig
  );

  useEffect(() => {
    if (!storageConfig) {
      return;
    }

    const visible = Array.isArray(storageConfig.visible) ? storageConfig.visible : [];
    const hidden = Array.isArray(storageConfig.hidden) ? storageConfig.hidden : [];
    const storedConfig =
      visible === storageConfig.visible && hidden === storageConfig.hidden
        ? storageConfig
        : { visible, hidden };

    const newConfig = syncColumnsOrder(storedConfig, defaultConfig);

    if (newConfig !== storageConfig) {
      setStorageConfig(newConfig);
    }
  }, [defaultConfig, storageConfig, setStorageConfig]);
};
